import(/* webpackMode: "eager" */ "/app/src/components/breadcrumbs/breadcrumbs.tsx");
import(/* webpackMode: "eager" */ "/app/src/components/contacts/contacts.module.scss")